// extracted by mini-css-extract-plugin
export var aircallIframe = "_dr-3";
export var fabContainer = "_dr-5";
export var fabRinging = "_dr-6";
export var loadingOverlay = "_dr-4";
export var pulse = "_dr-7";
export var widgetContent = "_dr-2";
export var widgetPanel = "_dr-0";
export var widgetPanelExpanded = "_dr-1";